import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

class EditBucketModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name: props.bucket.name,
            description: props.bucket.description || '',
        };
    }

    onNameChange = e => {
        this.setState({ name: e.target.value });
    };

    onUpdateBucketTitle = e => {
        if (e && e.key === 'Enter') {
            const { name } = this.state;
            if (name !== '') {
                this.onUpdateBucket();
            }
        }
    };

    onDescriptionChange = e => {
        this.setState({ description: e.target.value });
    };

    onUpdateBucket = () => {
        const { name, description } = this.state;

        this.props.onUpdateBucket({
            id: this.props.bucket.id,
            name,
            description,
        });
        this.props.onClose();
    };

    render() {
        const { show, classes, onClose } = this.props;

        if (!show) {
            return null;
        }

        const { name, description } = this.state;

        return (
            <React.Fragment>
                <Dialog open={true} onClose={onClose}>
                    <DialogTitle>Edit Project</DialogTitle>
                    <DialogContent>
                        <div className={classes.content}>
                            <TextField
                                required
                                label="Project name"
                                onChange={this.onNameChange}
                                onKeyPress={this.onUpdateBucketTitle}
                                value={name}
                            />
                            <TextField
                                multiline
                                rows="10"
                                label="Project description"
                                onChange={this.onDescriptionChange}
                                inputProps={{
                                    maxLength: 350,
                                }}
                                value={description}
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onClose}>CANCEL</Button>

                        <Button
                            onClick={this.onUpdateBucket}
                            color="primary"
                            variant="contained"
                        >
                            UPDATE PROJECT
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

EditBucketModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    bucket: PropTypes.object.isRequired,
};

EditBucketModal.defaultProps = {
    show: false,
};

const style = ({ spacing }) => ({
    content: {
        display: 'flex',
        flexDirection: 'column',
    },
    icon: {
        composes: ['material-icons'],
        marginRight: spacing.unit,
    },
});

export default injectSheet(style)(EditBucketModal);



// WEBPACK FOOTER //
// ./src/components/modals/EditBucketModal.js